import React, { ChangeEventHandler, FC, MouseEventHandler, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import DatePicker from 'react-calendar'
import { format as formatDate, parseISO, set as setDate } from 'date-fns'
import { clamp, Config } from '../../common'
import Form from '../../components/Form'

interface Props {
  value?: string
  onChange?: (date: Date) => void
}

const PickupDate: FC<Props> = ({ value, onChange, children }) => {
  const [modalVisible, setModalVisible] = useState(false)
  const formattedDate = value ? formatDate(parseISO(value), Config.DateFormat) : ''
  const formattedTime = value ? formatDate(parseISO(value), Config.TimeFormat) : ''
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)

  const [datetime, setDatetime] = useState<Date>(value ? parseISO(value) : new Date())
  const [hour, setHour] = useState<string>(datetime.getHours().toString())
  const [minute, setMinute] = useState<string>(datetime.getMinutes().toString().padStart(2, '0'))

  const toggleModal = () => {
    setModalVisible(!modalVisible)
  }

  const handleDateSelected = (date: Date) => {
    setDatetime(
      setDate(date, {
        hours: clamp(Number(hour), 0, 23),
        minutes: clamp(Number(minute), 0, 59),
      })
    )
  }

  useEffect(() => {
    setDatetime(
      setDate(datetime, {
        hours: clamp(Number(hour), 0, 23),
        minutes: clamp(Number(minute), 0, 59),
      })
    )
  }, [hour, minute])

  const handleDateFinished: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault()

    onChange?.(datetime)
    toggleModal()
  }

  const handleMinuteInput: ChangeEventHandler<HTMLInputElement> = (event) => {
    const minute = Number(event.target.value)

    if (minute >= 0 && minute <= 59) {
      setMinute(minute.toString().padStart(2, '0'))
    }
  }

  const handleHourInput: ChangeEventHandler<HTMLInputElement> = (event) => {
    const hour = Number(event.target.value)

    if (hour >= 0 && hour <= 23) {
      setHour(hour.toString())
    }
  }
  return (
    <div className="booking-input-single booking-input-passengers mb-4 position-relative">
      <div className="passengers-left-icon position-absolute">
        <span className="icon-calendar-small"></span>
      </div>
      <div className="passengers-wrap form-control d-flex align-items-center">
        {formattedDate ? (
          <>
            <span className="placeholder-text text-secondary">Pick up:</span>
            <span className="text-secondary pl-1">
              {formattedDate} at {formattedTime}
            </span>
          </>
        ) : (
          <span className="placeholder-text text-secondary">Pick up date and time</span>
        )}
      </div>

      {children}

      <button
        type="button"
        className="passengers-edit text-secondary position-absolute bg-light-blue p-1 btn btn-link"
        onClick={toggleModal}
      >
        <span className="icon-pencil"></span>
      </button>

      <Modal show={modalVisible} onHide={toggleModal} contentclassname="pickuptime-model" centered>
        <Modal.Body>
          <div className="pickup-time-wrap d-flex bg-light-blue p-4 align-items-center">
            <div className="pickup-time-left flex-grow-1">
              <span>Pick up time</span>
            </div>
            <div className="pickup-time-right d-flex">
              <input
                type="number"
                min="0"
                max="24"
                className="form-control form-control-lg mr-2 text-center"
                id="pickuptime_hour"
                value={hour}
                onChange={handleHourInput}
              />
              <input
                type="number"
                min="0"
                max="60"
                className="form-control form-control-lg text-center"
                id="pickuptime_mins"
                value={minute}
                onChange={handleMinuteInput}
              />
            </div>
          </div>
          <div className="passengers-model-wrap p-3">
            <div className="passengers-model-content">
              <DatePicker
                value={datetime}
                onChange={handleDateSelected}
                goToRangeStartOnSelect={false}
                minDate={tomorrow}
                view="month"
              />
            </div>
            <button
              type="button"
              className="btn btn-secondary btn-lg btn-block rounded-0 mt-4"
              onClick={handleDateFinished}
            >
              Done
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default PickupDate
